import { render, staticRenderFns } from "./iconPuzzle.vue?vue&type=template&id=846299be"
import script from "./iconPuzzle.vue?vue&type=script&lang=js"
export * from "./iconPuzzle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports